import { UtilDocumentId } from '@formbird/shared';
import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ClientConstants } from '../../../../formbird-services/src/lib/constants/ClientConstants';
import { BroadcastService } from '../../../../formbird-services/src/lib/services/broadcast/broadcast.service';
import { UnsavedDocumentService } from '../../../../formbird-services/src/lib/services/document/unsaved-document.service';

@Component({
  selector: 'ft-child-template',
  templateUrl: './child-template.component.html'
})
export class ChildTemplateComponent implements OnInit, OnDestroy {

  @Input() documentId: string;
  @Input() templateId: string;
  @Input() parentDocumentId: string;
  @Input() defaultFields: any;
  @Input() childDocumentInfo: any;
  @Input() parentFieldName: string;

  formGroup: FormGroup;
  private formParameters: any;
  private formId;

  private sub: any;

  constructor(
    private unsavedDocumentService: UnsavedDocumentService,
    private broadcastService: BroadcastService,
    private renderer: Renderer2,
    private el: ElementRef,
    private formBuilder: FormBuilder
  ) {
  }

  ngOnInit(): void {

    this.formGroup = this.formBuilder.group({});
    this.formId = UtilDocumentId.generateId();

    this.childDocumentInfo.hierarchyInfo.parentDocumentId = this.parentDocumentId;
    this.childDocumentInfo.documentId = this.documentId;

    this.formParameters = {
      parentDocumentId: this.parentDocumentId,
      formId: this.formId,
      selectedDocumentId: this.documentId ? this.documentId : this.templateId,
      defaultFields: this.defaultFields,
      unsavedDocumentListId: this.childDocumentInfo.documentListId,
      hierarchyInfo: this.childDocumentInfo.hierarchyInfo  // This info to be used in OnLoad rule
    };

    console.log('Init child template component:', this.formParameters);

    const customElement = this.renderer.createElement('ft-formbird-template');

    this.renderer.setStyle(customElement, 'padding-left', '20px');
    this.renderer.setStyle(customElement, 'flex-flow', 'row wrap');
    this.renderer.setStyle(customElement, 'box-sizing', 'border-box');
    this.renderer.setStyle(customElement, 'display', 'flex');

    // pass the parameters of the component to the custom element
    customElement.formParameters = this.formParameters;
    customElement.isMainDocument = false;
    customElement.formGroup = this.formGroup;

    customElement.defaultFields = this.defaultFields;

    // append element to container
    this.renderer.appendChild(this.el.nativeElement, customElement);

    const scrollTopElement = this.renderer.createElement('button');
    const iconElement = this.renderer.createElement('i');
    const text = this.renderer.createText('keyboard_arrow_up');

    this.renderer.addClass(iconElement, 'material-icons');
    this.renderer.appendChild(iconElement, text);
    this.renderer.appendChild(scrollTopElement, iconElement);

    this.renderer.addClass(scrollTopElement, 'btn');
    this.renderer.addClass(scrollTopElement, 'btn-primary');
    this.renderer.addClass(scrollTopElement, 'scrollTopChild');
    // this.renderer.setProperty(scrollTopElement, 'class', 'btn btn-raised btn-primary scrollTopChild');
    this.renderer.listen(scrollTopElement, 'click', (evt) => {
      document.getElementById('childDoc_' + this.parentFieldName).scrollIntoView({behavior: 'smooth'});
    });


    // this.renderer.setStyle(scrollTopElement, 'position', 'absolute');
    // append element to container
    this.renderer.appendChild(this.el.nativeElement, scrollTopElement);


    this.sub = this.broadcastService.on(ClientConstants.DOCUMENT_LOADED).subscribe((data: any) => {
      const documentData = data.documentData;
      const formParameter = data.formParameters;

      if (formParameter?.formId === this.formId) {

        if (!this.childDocumentInfo.documentId) {
          this.childDocumentInfo.documentId = documentData.documentId;
        }

        if (this.childDocumentInfo.documentId === documentData.templateId) {
          this.childDocumentInfo.documentId = documentData.documentId;
          this.childDocumentInfo.templateId = documentData.templateId;
        }

        if (formParameter.parentDocumentId &&
          formParameter.parentDocumentId === this.formParameters.parentDocumentId &&
          formParameter.unsavedDocumentListId === this.formParameters.unsavedDocumentListId) {
        
          this.unsavedDocumentService.updateDocumentListInfo(this.childDocumentInfo, this.childDocumentInfo.documentListId);
        }

        document.getElementById('childDoc_' + this.parentFieldName).scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
